import { isVansBeforeFlowRemoval } from '@/helpers/utils';
import {
  SET_SUBCAMPAIGN_SUMMARY, MODIFY_SUBCAMPAIGN_FEEDBACK, SET_SUBCAMPAIGN_NOTES,
  MODIFY_SUBCAMPAIGN_DESCRIPTION_NOTES, MODIFY_SUBCAMPAIGN_CLASSIFICATION_NOTES, MODIFY_SUBCAMPAIGN_ORIGINAL_VALUES,
  MODIFY_SUBCAMPAIGN_HARDWARE_NOTES, MODIFY_SUBCAMPAIGN_SOFTWARE_NOTES, MODIFY_SUBCAMPAIGN_VEHICLES_NOTES,
  MODIFY_SUBCAMPAIGN_INFO, SET_SUBCAMPAIGN_PLANTFEEDBACK, SET_SUBCAMPAING_NOTES_BY_TAB, SET_FEEDBACK_VALIDATIONS,
  SET_VALIDATIONS_SUBCR, RESET_SUBCAMPAIGN,
} from '../types';

const initialState = {
  summary: {},
  feedback: {
    campaigns: [{}],
  },
  subCampaignInfo: {},
  descriptionComments: {},
  classificationComments: {},
  hardwareComments: {},
  softwareComments: {},
  originalValues: {
    hasChange: false,
    values: {},
  },
  validations: {},
};

export default (state = initialState, action) => {
  let newState = {};

  switch (action.type) {
    case SET_SUBCAMPAIGN_SUMMARY:
      newState = { summary: action.payload };
      break;
    case MODIFY_SUBCAMPAIGN_FEEDBACK:
      newState = { feedback: action.payload };
      break;
    case SET_SUBCAMPAIGN_NOTES:
      newState = {
        notes: action.payload,
        descriptionNotes: action.payload?.notes.find((note) => note.module === 'DESCRIPTION').notes,
        classificationNotes: action.payload?.notes.find((note) => note.module === 'CLASSIFICATION').notes,
        hardwareNotes: action.payload?.notes.find((note) => note.module === 'AFFECTED_HARDWARE').notes,
        softwareNotes: action.payload?.notes.find((note) => note.module === 'AFFECTED_SOFTWARE').notes,
        vehiclesNotes: action.payload?.notes.find((note) => note.module === 'AFFECTED_VEHICLES').notes,
      };
      break;
    case SET_SUBCAMPAING_NOTES_BY_TAB:
      newState = { [action.payload?.tab]: action.payload?.notes };
      break;
    case MODIFY_SUBCAMPAIGN_DESCRIPTION_NOTES:
      newState = { descriptionNotes: action.payload };
      break;
    case MODIFY_SUBCAMPAIGN_CLASSIFICATION_NOTES:
      newState = { classificationNotes: action.payload };
      break;
    case MODIFY_SUBCAMPAIGN_HARDWARE_NOTES:
      newState = { hardwareNotes: action.payload };
      break;
    case MODIFY_SUBCAMPAIGN_SOFTWARE_NOTES:
      newState = { softwareNotes: action.payload };
      break;
    case MODIFY_SUBCAMPAIGN_VEHICLES_NOTES:
      newState = { vehiclesNotes: action.payload };
      break;
    case MODIFY_SUBCAMPAIGN_INFO:
      newState = { subCampaignInfo: action.payload };
      break;
    case MODIFY_SUBCAMPAIGN_ORIGINAL_VALUES:
      newState = { originalValues: action.payload };
      break;
    case SET_SUBCAMPAIGN_PLANTFEEDBACK:
      newState = { plantFeedback: action.payload };
      break;
    case SET_VALIDATIONS_SUBCR:
      newState = { validations: action.payload };
      break;
    case SET_FEEDBACK_VALIDATIONS:
      newState = {
        validations: {
          ...state.validations,
          feedback: action.payload,
        },
      };
      break;
    default:
      newState = {};
  }

  return action.type === RESET_SUBCAMPAIGN
    ? initialState
    : {
      ...state,
      ...newState,
    };
};

export const getSubCampaign = (state) => state.subCampaignReducer;
export const getSubCampaignSummary = (state) => state.subCampaignReducer.summary;
export const getSubCampaignFeedback = (state) => state.subCampaignReducer.feedback;
export const getSubcampaignComments = (state) => state.subCampaignReducer.notes;
export const getSubcampaignDescriptionNotes = (state) => state.subCampaignReducer.descriptionNotes;
export const getSubcampaignClassificationNotes = (state) => state.subCampaignReducer.classificationNotes;
export const getSubcampaignHardwareNotes = (state) => state.subCampaignReducer.hardwareNotes;
export const getSubcampaignSoftwareNotes = (state) => state.subCampaignReducer.softwareNotes;
export const getSubcampaignVehiclesNotes = (state) => state.subCampaignReducer.vehiclesNotes;
export const getSubCampaignInfo = (state) => state.subCampaignReducer.subCampaignInfo;
export const getSubCampaignOriginalValues = (state) => state.subCampaignReducer.originalValues;
export const getSubCampaignPlantFeedback = (state) => state.subCampaignReducer.plantFeedback;
export const getSubCampaignValidations = (state) => state.subCampaignReducer.validations;
export const getFeedbackValidations = (state) => state.subCampaignReducer.validations?.feedback;
export const getIsVANSubCR = (state) => isVansBeforeFlowRemoval(
  state?.subCampaignReducer?.subCampaignInfo?.type, state?.subCampaignReducer?.subCampaignInfo?.creationDate,
);
